import type { SvgComponent } from '@/types/SvgComponent';

export const UndoIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}

      <path
        d="M7.125 12.75L2.625 8.25L7.125 3.75"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 18.75H15.375C16.7674 18.75 18.1027 18.1969 19.0873 17.2123C20.0719 16.2277 20.625 14.8924 20.625 13.5C20.625 12.1076 20.0719 10.7723 19.0873 9.78769C18.1027 8.80312 16.7674 8.25 15.375 8.25H2.625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
